import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import texts from '../texts.json';
import { ImageFrame } from './style';

const PreviewImage = ({ src }) => (
  <ImageFrame>
    <Box
      component="img"
      src={src}
      alt={texts.sections.image.alt}
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
      }}
    />
  </ImageFrame>
);

PreviewImage.propTypes = {
  src: PropTypes.string.isRequired,
};

export default PreviewImage;
